import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';
import { format, isToday } from 'date-fns';
import { localeMap } from '../../models/locale.interface';

@Pipe({
  name: 'formatDate',
})
export class FormatDatePipe implements PipeTransform {
  private locale = inject(LOCALE_ID);

  private readonly defaultTimeFormat = 'HH:mm';
  private readonly defaultDateFormat = 'yy.MM.dd';
  private readonly defaultDateTimeFormat = `${this.defaultDateFormat} ${this.defaultTimeFormat}`;
  private readonly todayStr = $localize`Today`;

  transform(
    date: string | number | Date,
    dateFormat: string = this.defaultDateTimeFormat,
    showTodayLabel: boolean = false
  ) {
    if (
      showTodayLabel &&
      isToday(date) &&
      dateFormat.includes(this.defaultDateFormat)
    ) {
      return dateFormat.includes(this.defaultTimeFormat)
        ? `${this.todayStr} ${format(date, this.defaultTimeFormat)}`
        : this.todayStr;
    }

    return format(new Date(date), dateFormat, {
      locale: localeMap[this.locale],
    });
  }
}
